import { Injectable } from '@angular/core';

interface TinyMceProps {
  fonts?: boolean;
  fontSize?: boolean;
  fontFamily?: boolean;
  formatting?: boolean;
  lists?: boolean;
  justify?: boolean;
  tables?: boolean;
  hyperlinks?: boolean;
  images?: boolean;
  undo?: boolean;
  editHtml?: boolean;
  height?: number;
  forceLinkPrefix?: boolean;
  block_formats?: string;
  images_upload_handler?: (blobInfo: any, progress: (percent: number) => void) => Promise<string>;
}

@Injectable({
  providedIn: 'root'
})
export class TinymceConfigHelperService {

  getTinyMceConfig(props: TinyMceProps = {}) {
    const opts = {
      fonts: true,
      fontSize: false,
      fontFamily: false,
      formatting: true,
      lists: true,
      justify: true,
      tables: true,
      hyperlinks: true,
      images: true,
      undo: true,
      editHtml: true,
      height: 300,
      forceLinkPrefix: true,
      block_formats: 'Paragraph=p;Heading 1=h1;Heading 2=h2;Heading 3=h3',
      ...props
    };

    const plugins = ['link', 'image', 'table', 'code', 'autoresize'];
    if (opts.lists) plugins.push('lists');

    const toolbarSegments = [
      opts.fonts && 'styles',
      opts.fontFamily && 'fontfamily',
      opts.fontSize && 'fontsize',
      opts.formatting && 'bold italic underline strikethrough | blockquote',
      opts.lists && 'bullist numlist',
      opts.justify && 'alignleft aligncenter alignright alignjustify | indent outdent',
      opts.hyperlinks && 'link unlink',
      opts.images && 'image',
      opts.tables && 'table',
      opts.undo && 'undo redo',
      opts.editHtml && 'code',
    ];

    const toolbar = toolbarSegments.filter(Boolean).join(' | ');

    return {
      plugins: plugins.join(' '),
      toolbar,
      height: opts.height,
      menubar: false,
      branding: false,
      block_formats: opts.block_formats,
      paste_data_images: true,
      default_link_target: '_blank',
      convert_urls: false,
      automatic_uploads: true,
      images_upload_handler: opts.images_upload_handler,
      setup: (editor: any) => {
        if (!opts.forceLinkPrefix) return;
        
        editor.on('BeforeSetContent', (e: any) => {
          if (typeof e.content !== 'string') return;

          const doc = new DOMParser().parseFromString(e.content, 'text/html');
          doc.querySelectorAll('a[href]').forEach(link => {
            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener noreferrer');

            const href = link.getAttribute('href');
            if (href && !/^(https?:\/\/|mailto:|tel:|\/|#)/i.test(href)) {
              link.setAttribute('href', `http://${href}`);
            }
          });
          e.content = doc.body.innerHTML;
        });
      },
    };
  }
}